import { Attr, Model } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class Extra extends ApplicationRecord {
  static jsonapiType = 'extras';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Base Price',
        value: 'basePrice',
      },
      {
        text: 'Type',
        value: 'extraType',
      },
    ];
  }

  static scopeFactory() {
    return Extra.includes([]);
  }

  @Attr() name: string;
  @Attr() basePrice: string;
  @Attr() description: string;
  @Attr() extraType: string;
  @Attr() public: boolean = true;
  @Attr() readonly available: boolean;

  get formattedPrice() {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(Number(this.basePrice));
  }
}
